import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "app-package-download-page" }
const _hoisted_2 = { class: "page-shell" }
const _hoisted_3 = { class: "hero-section" }
const _hoisted_4 = { class: "hero-top" }
const _hoisted_5 = { class: "hero-brand" }
const _hoisted_6 = { class: "hero-logo" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "hero-actions" }
const _hoisted_9 = { class: "platform-grid" }
const _hoisted_10 = { class: "platform-card platform-card--android" }
const _hoisted_11 = { class: "platform-card__body" }
const _hoisted_12 = { class: "platform-info-row" }
const _hoisted_13 = { class: "platform-info-value" }
const _hoisted_14 = { class: "android-qrcode" }
const _hoisted_15 = { class: "android-qrcode__box" }
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 1,
  class: "android-qrcode__placeholder"
}
const _hoisted_18 = { class: "platform-card platform-card--harmony" }
const _hoisted_19 = { class: "platform-card__body" }
const _hoisted_20 = { class: "android-qrcode" }
const _hoisted_21 = { class: "android-qrcode__box" }
const _hoisted_22 = ["src"]
const _hoisted_23 = {
  key: 1,
  class: "android-qrcode__placeholder"
}
const _hoisted_24 = { class: "platform-card platform-card--windows" }
const _hoisted_25 = { class: "platform-card__body" }
const _hoisted_26 = { class: "platform-info-row" }
const _hoisted_27 = { class: "platform-info-value" }

import { computed, onMounted, ref } from 'vue'
import { ElMessage } from 'element-plus'
import QRCode from 'qrcode'
import AppVersionAdminApi from '@/network/apis/AppVersionAdmin'
import logoImage from '@/assets/img/Logo.png'

const windowsRuntimeFileName = 'windowsdesktop-runtime-8.0.25-win-x64.exe'
const instructionUrl = 'https://cabrjyzt.feishu.cn/wiki/FVWHw2p5IiO2Jkk60cAc8lkfnub'
const feedbackUrl = 'https://www.feishu.cn/invitation/page/add_contact/?token=f11rdaeb-4cb8-43f0-a202-e27bce06f55d'
const HARMONY_MANIFEST_URL = 'https://zjys.cabr-betc.com/api/HarmonyApp/ManifestDownload/manifest.json5'
const HARMONY_QR_PAGE_URL = 'https://zjys.cabr-betc.com/app-package-download'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const androidLoading = ref(false)
const windowsLoading = ref(false)
const latestAndroidVersion = ref('')
const latestWindowsVersion = ref('')
const androidQrCodeUrl = ref('')
const harmonyQrCodeUrl = ref('')
const androidDownloadUrl = ref('')
const HARMONY_STORE_URL = `store://enterprise/manifest?url=${encodeURIComponent(HARMONY_MANIFEST_URL)}`
const androidVersionText = computed(() => latestAndroidVersion.value || '正在获取')
const windowsVersionText = computed(() => latestWindowsVersion.value || '正在获取')

const getAbsoluteDownloadUrl = (fileName: string) => {
  const downloadUrl = AppVersionAdminApi.getPublicDownloadUrl(fileName)
  return new URL(downloadUrl, window.location.origin).toString()
}

const getQrDownloadUrl = (fileName: string) => {
  const publicBaseUrl = window.PROJECT_CONFIG?.PUBLIC_DOWNLOAD_BASE_URL
  const downloadUrl = AppVersionAdminApi.getPublicDownloadUrl(fileName, publicBaseUrl)
  return new URL(downloadUrl, window.location.origin).toString()
}

const triggerDownload = (fileName: string) => {
  window.location.assign(getAbsoluteDownloadUrl(fileName))
}

const openExternalLink = (url: string) => {
  window.open(url, '_blank', 'noopener,noreferrer')
}

const generateAndroidQrCode = async (fileName: string) => {
  if (!fileName) {
    androidQrCodeUrl.value = ''
    return
  }

  try {
    androidDownloadUrl.value = getQrDownloadUrl(fileName)
    androidQrCodeUrl.value = await QRCode.toDataURL(androidDownloadUrl.value, {
      width: 180,
      margin: 1,
      errorCorrectionLevel: 'M',
    })
  } catch (error) {
    console.error('生成安卓下载二维码失败:', error)
    androidQrCodeUrl.value = ''
  }
}

const generateHarmonyQrCode = async () => {
  try {
    harmonyQrCodeUrl.value = await QRCode.toDataURL(HARMONY_QR_PAGE_URL, {
      width: 180,
      margin: 1,
      errorCorrectionLevel: 'M',
    })
  } catch (error) {
    console.error('生成鸿蒙下载二维码失败:', error)
    harmonyQrCodeUrl.value = ''
  }
}

const loadLatestAndroidVersion = async () => {
  try {
    const res = await AppVersionAdminApi.checkLatestVersionPublic('安卓')
    latestAndroidVersion.value = res?.response?.版本号 || ''
    const fileName = res?.response?.文件名
    await generateAndroidQrCode(fileName || '')
  } catch (error) {
    console.error('获取安卓最新版本失败:', error)
    latestAndroidVersion.value = ''
    androidDownloadUrl.value = ''
    androidQrCodeUrl.value = ''
  }
}

const loadLatestWindowsVersion = async () => {
  try {
    const res = await AppVersionAdminApi.checkLatestVersionPublic('windows')
    latestWindowsVersion.value = res?.response?.版本号 || ''
  } catch (error) {
    console.error('获取Windows最新版本失败:', error)
    latestWindowsVersion.value = ''
  }
}

const handleDownload = async (type: string) => {
  if (type !== '安卓' && type !== 'windows') {
    ElMessage.warning(`${type}版本暂未开放下载`)
    return
  }

  const isWindows = type === 'windows'
  const loadingRef = isWindows ? windowsLoading : androidLoading
  const versionRef = isWindows ? latestWindowsVersion : latestAndroidVersion
  const requestType = isWindows ? 'windows' : '安卓'
  const displayType = isWindows ? 'Windows' : '安卓'

  loadingRef.value = true
  try {
    const res = await AppVersionAdminApi.checkLatestVersionPublic(requestType)
    const fileName = res?.response?.文件名
    const version = res?.response?.版本号

    if (!fileName) {
      ElMessage.warning('未获取到最新安装包文件名')
      return
    }

    versionRef.value = version || ''
    if (!isWindows) {
      await generateAndroidQrCode(fileName)
    }
    triggerDownload(fileName)
  } catch (error) {
    console.error(`获取${displayType}安装包失败:`, error)
    ElMessage.error(`${displayType}安装包下载失败，请稍后重试`)
  } finally {
    loadingRef.value = false
  }
}

const handleWindowsRuntimeDownload = () => {
  triggerDownload(windowsRuntimeFileName)
}

const handleHarmonyDownload = () => {
  window.location.href = HARMONY_STORE_URL
}

onMounted(() => {
  loadLatestAndroidVersion()
  loadLatestWindowsVersion()
  generateHarmonyQrCode()
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                src: _unref(logoImage),
                alt: "Logo",
                class: "hero-logo__image"
              }, null, 8, _hoisted_7)
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "hero-badge" }, "公开下载页", -1))
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_el_button, {
              plain: "",
              class: "hero-action-btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (openExternalLink(instructionUrl)))
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode(" 操作说明 ")
              ])),
              _: 1
            }),
            _createVNode(_component_el_button, {
              plain: "",
              class: "hero-action-btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (openExternalLink(feedbackUrl)))
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode(" 问题反馈 ")
              ])),
              _: 1
            })
          ])
        ]),
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "hero-title" }, "智能检测客户端安装包下载", -1)),
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "hero-meta" }, null, -1))
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _cache[12] || (_cache[12] = _createStaticVNode("<div class=\"platform-card__head\" data-v-c331cdae><div class=\"platform-card__title-wrap\" data-v-c331cdae><span class=\"platform-card__icon platform-card__icon--android\" data-v-c331cdae><svg viewBox=\"0 0 64 64\" aria-hidden=\"true\" class=\"platform-card__svg\" data-v-c331cdae><path d=\"M22 18 17 10.5\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.8\" stroke-linecap=\"round\" data-v-c331cdae></path><path d=\"M42 18 47 10.5\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.8\" stroke-linecap=\"round\" data-v-c331cdae></path><path d=\"M20 20c0-7 5.4-12 12-12s12 5 12 12v4H20v-4Z\" fill=\"currentColor\" data-v-c331cdae></path><rect x=\"16\" y=\"22\" width=\"32\" height=\"24\" rx=\"7\" fill=\"currentColor\" data-v-c331cdae></rect><rect x=\"8\" y=\"23\" width=\"6.5\" height=\"18\" rx=\"3.2\" fill=\"currentColor\" data-v-c331cdae></rect><rect x=\"49.5\" y=\"23\" width=\"6.5\" height=\"18\" rx=\"3.2\" fill=\"currentColor\" data-v-c331cdae></rect><rect x=\"23\" y=\"44\" width=\"6.5\" height=\"14\" rx=\"3.2\" fill=\"currentColor\" data-v-c331cdae></rect><rect x=\"34.5\" y=\"44\" width=\"6.5\" height=\"14\" rx=\"3.2\" fill=\"currentColor\" data-v-c331cdae></rect><circle cx=\"26\" cy=\"19\" r=\"2.3\" fill=\"#ffffff\" data-v-c331cdae></circle><circle cx=\"38\" cy=\"19\" r=\"2.3\" fill=\"#ffffff\" data-v-c331cdae></circle></svg></span><div class=\"platform-card__title\" data-v-c331cdae>安卓版本</div></div><span class=\"platform-card__tag platform-card__tag--active\" data-v-c331cdae>已接通</span></div>", 1)),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _cache[9] || (_cache[9] = _createElementVNode("span", { class: "platform-info-label" }, "最新版本", -1)),
              _createElementVNode("span", _hoisted_13, _toDisplayString(androidVersionText.value), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                (androidQrCodeUrl.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: androidQrCodeUrl.value,
                      alt: "安卓版本下载二维码",
                      class: "android-qrcode__image"
                    }, null, 8, _hoisted_16))
                  : (_openBlock(), _createElementBlock("div", _hoisted_17, "二维码生成中"))
              ]),
              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "android-qrcode__text" }, "微信或浏览器扫码下载", -1))
            ])
          ]),
          _createVNode(_component_el_button, {
            type: "success",
            size: "large",
            class: "platform-download-btn",
            loading: androidLoading.value,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (handleDownload('安卓')))
          }, {
            default: _withCtx(() => _cache[11] || (_cache[11] = [
              _createElementVNode("span", { class: "btn-text-desktop" }, "安卓版本下载", -1),
              _createElementVNode("span", { class: "btn-text-mobile" }, "下载", -1)
            ])),
            _: 1
          }, 8, ["loading"])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _cache[16] || (_cache[16] = _createStaticVNode("<div class=\"platform-card__head\" data-v-c331cdae><div class=\"platform-card__title-wrap\" data-v-c331cdae><span class=\"platform-card__icon platform-card__icon--harmony\" data-v-c331cdae><svg viewBox=\"0 0 210 48\" aria-hidden=\"true\" class=\"platform-card__svg platform-card__svg--harmony\" data-v-c331cdae><text x=\"0\" y=\"33\" font-size=\"30\" font-weight=\"700\" fill=\"currentColor\" font-family=\"Arial, Helvetica, sans-serif\" data-v-c331cdae>Harmony</text><text x=\"129\" y=\"33\" font-size=\"30\" font-weight=\"700\" fill=\"currentColor\" font-family=\"Arial, Helvetica, sans-serif\" data-v-c331cdae>OS</text><rect x=\"128\" y=\"37\" width=\"28\" height=\"4\" rx=\"2\" fill=\"#2f6df6\" data-v-c331cdae></rect></svg></span><div class=\"platform-card__title\" data-v-c331cdae>鸿蒙版本</div></div><span class=\"platform-card__tag platform-card__tag--active\" data-v-c331cdae>已接入</span></div>", 1)),
          _createElementVNode("div", _hoisted_19, [
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "platform-info-row" }, [
              _createElementVNode("span", { class: "platform-info-label" }, "当前状态"),
              _createElementVNode("span", { class: "platform-info-value" }, "可跳转至鸿蒙企业应用市场安装")
            ], -1)),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                (harmonyQrCodeUrl.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: harmonyQrCodeUrl.value,
                      alt: "鸿蒙版本下载二维码",
                      class: "android-qrcode__image"
                    }, null, 8, _hoisted_22))
                  : (_openBlock(), _createElementBlock("div", _hoisted_23, "二维码生成中"))
              ]),
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "android-qrcode__text" }, "请使用鸿蒙设备扫码后打开本下载页", -1))
            ])
          ]),
          _createVNode(_component_el_button, {
            type: "warning",
            size: "large",
            class: "platform-download-btn",
            onClick: handleHarmonyDownload
          }, {
            default: _withCtx(() => _cache[15] || (_cache[15] = [
              _createElementVNode("span", { class: "btn-text-desktop" }, "鸿蒙版本下载", -1),
              _createElementVNode("span", { class: "btn-text-mobile" }, "下载", -1)
            ])),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_24, [
          _cache[20] || (_cache[20] = _createStaticVNode("<div class=\"platform-card__head\" data-v-c331cdae><div class=\"platform-card__title-wrap\" data-v-c331cdae><span class=\"platform-card__icon platform-card__icon--windows\" data-v-c331cdae><svg viewBox=\"0 0 64 64\" aria-hidden=\"true\" class=\"platform-card__svg\" data-v-c331cdae><path d=\"M8 12 29 9v22H8V12Z\" fill=\"currentColor\" data-v-c331cdae></path><path d=\"M33 8.5 56 5v25H33V8.5Z\" fill=\"currentColor\" data-v-c331cdae></path><path d=\"M8 35h21v20L8 52V35Z\" fill=\"currentColor\" data-v-c331cdae></path><path d=\"M33 35h23V59l-23-3V35Z\" fill=\"currentColor\" data-v-c331cdae></path></svg></span><div class=\"platform-card__title\" data-v-c331cdae>Windows版本</div></div><span class=\"platform-card__tag platform-card__tag--active\" data-v-c331cdae>已接通</span></div>", 1)),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _cache[17] || (_cache[17] = _createElementVNode("span", { class: "platform-info-label" }, "最新版本", -1)),
              _createElementVNode("span", _hoisted_27, _toDisplayString(windowsVersionText.value), 1)
            ])
          ]),
          _createVNode(_component_el_button, {
            plain: "",
            type: "primary",
            class: "platform-runtime-btn",
            onClick: handleWindowsRuntimeDownload
          }, {
            default: _withCtx(() => _cache[18] || (_cache[18] = [
              _createElementVNode("span", { class: "runtime-text-desktop" }, "下载运行环境", -1),
              _createElementVNode("span", { class: "runtime-text-mobile" }, "运行环境", -1)
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            size: "large",
            class: "platform-download-btn",
            loading: windowsLoading.value,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (handleDownload('windows')))
          }, {
            default: _withCtx(() => _cache[19] || (_cache[19] = [
              _createElementVNode("span", { class: "btn-text-desktop" }, "Windows版本下载", -1),
              _createElementVNode("span", { class: "btn-text-mobile" }, "下载", -1)
            ])),
            _: 1
          }, 8, ["loading"])
        ])
      ])
    ])
  ]))
}
}

})